// extracted by mini-css-extract-plugin
export default {"heading":"SectionHeading_heading__M4We0","center":"SectionHeading_center__3HJNy","eyebrow":"SectionHeading_eyebrow__UTXaV","text":"SectionHeading_text__zMjSt"};